import { render } from "./CSliderPage.vue?vue&type=template&id=11e21523&scoped=true"
import script from "./CSliderPage.vue?vue&type=script&lang=js"
export * from "./CSliderPage.vue?vue&type=script&lang=js"

import "./CSliderPage.vue?vue&type=style&index=0&id=11e21523&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11e21523"]])

export default __exports__